import { useEffect } from 'react';

interface ShortcutCallbacks {
  onNewNote?: () => void;
  onFocusSearch?: () => void;
}

export function useNotesShortcuts({ onNewNote, onFocusSearch }: ShortcutCallbacks) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const mod = e.metaKey || e.ctrlKey;

      // Cmd/Ctrl + N → new note
      if (mod && e.key === 'n') {
        e.preventDefault();
        onNewNote?.();
      }

      // Cmd/Ctrl + Shift + F → focus search
      if (mod && e.shiftKey && e.key === 'f') {
        e.preventDefault();
        onFocusSearch?.();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onNewNote, onFocusSearch]);
}
